import styled from 'styled-components';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  padding: 16px;
  .top-wrap {
    width: 100%;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    background: linear-gradient(180deg, #3a3851 0%, #2f2e41 68.79%, #1c1c2b 100%);
  }
  .bottom-wrap {
    display: flex;
    flex-flow: row wrap;
    padding: 16px;
    &--half {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
    &--full {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    margin-top: 16px;
    height: auto;
  }
`;
